import http from './http';
import { getCsrfToken } from '../utils/csrf';
import type { NavigationResponse } from '../types/navigation.types';

export async function getNavigation() {
    const response = await http.get<NavigationResponse>('/api/get-navigation');
    return response.data.navigation;
}

export async function switchNavigationApp(appId: number) {
    const response = await http.post(
        `/admin/apps/${appId}/switch`,
        {},
        {
            headers: {
                'X-CSRF-TOKEN': getCsrfToken(),
            },
        },
    );

    return response.data;
}
